import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter as Router } from "react-router-dom";
import { AuthProvider } from "./auth/AuthContext";
import { GamesCatalogProvider } from "./context/GamesCatalogContext";
import { LanguageProvider } from "./i18n/LanguageContext";

ReactDOM.createRoot(document.getElementById("root")).render(
  <Router>
    <LanguageProvider>
      <AuthProvider>
        <GamesCatalogProvider>
          <App />
        </GamesCatalogProvider>
      </AuthProvider>
    </LanguageProvider>
  </Router>
);
